// src/pages/InactiveAccountPage.jsx - ИСПРАВЛЕННАЯ ВЕРСИЯ
import React, { useState, useEffect } from 'react';
import { Container, Card, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const InactiveAccountPage = () => {
  const navigate = useNavigate();
  const { logout, clearInactiveStatus } = useAuth();
  const [checking, setChecking] = useState(false);
  const [message, setMessage] = useState('');
  const [autoChecking, setAutoChecking] = useState(true);

  // Функция для получения актуального статуса пользователя
  const checkAccountStatus = async () => {
    setChecking(true);
    setMessage('');
    
    try {
      const token = localStorage.getItem('access_token');
      
      if (!token) {
        setMessage('Токен не найден. Пожалуйста, войдите снова.');
        // ✅ Убираем авто-редирект, показываем кнопку
        setAutoChecking(false);
        return { success: false, active: false };
      }
      
      const response = await fetch('https://taskit.hsbk.ru/api/v1/users/me', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'X-API-Key': window.env?.VITE_API_KEY || 'web_site'
        }
      });
      
      if (response.ok) {
        const userData = await response.json();
        
        if (userData && userData.is_active === true) {
          console.log('✅ Account is now active!');
          
          // ОЧИЩАЕМ ФЛАГ НЕАКТИВНОСТИ
          localStorage.removeItem('inactive_reason');
          
          setMessage('✅ Ваш аккаунт активирован! Перенаправляем...');
          
          setTimeout(() => {
            window.location.href = '/_admin/profile';
          }, 1500);
          
          return { success: true, active: true };
        } else {
          console.log('❌ Account still inactive');
          setMessage('❌ Аккаунт все еще неактивен');
          return { success: true, active: false };
        }
      } else if (response.status === 401) {
        setMessage('Сессия истекла. Пожалуйста, войдите снова.');
        localStorage.removeItem('access_token');
        // ✅ НЕ УДАЛЯЕМ inactive_reason здесь
        setAutoChecking(false);
        return { success: false, active: false };
      } else {
        setMessage('Не удалось проверить статус. Попробуйте позже.');
        return { success: false, active: false };
      }
    } catch (error) {
      console.error('Error checking status:', error);
      setMessage('Ошибка соединения с сервером');
      return { success: false, active: false };
    } finally {
      setChecking(false);
      setAutoChecking(false);
    }
  };

  // Автоматическая проверка статуса при загрузке страницы
  useEffect(() => {
    checkAccountStatus();
  }, []);

  const handleForceCheck = async () => {
    await checkAccountStatus();
  };

  const handleGoToLogin = () => {
    logout();
     localStorage.removeItem('inactive_reason');
                // window.location.reload();
    navigate('/_admin/login');
  };

  // Получаем причину из localStorage
  const getInactiveReason = () => {
    try {
      const reason = localStorage.getItem('inactive_reason');
      return reason ? JSON.parse(reason) : null;
    } catch {
      return null;
    }
  };

  const reason = getInactiveReason();

  return (
    <Container fluid className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <Card className="border-warning shadow-lg" style={{ maxWidth: '500px' }}>
        <Card.Header className="bg-warning text-white text-center py-3">
          <i className="bi bi-exclamation-triangle-fill fs-1"></i>
        </Card.Header>
        <Card.Body className="p-4 text-center">
          <h2 className="text-warning mb-4">Доступ запрещен</h2>
          
          <div className="mb-4">
            <p className="fs-5 mb-2">Ваш аккаунт деактивирован</p>
            <p className="text-muted">
              Обратитесь к администратору для активации аккаунта.
            </p>
          </div>

          {reason && (
            <div className="bg-light p-3 rounded mb-4 text-start">
              <p className="mb-2">
                <i className="bi bi-info-circle me-2 text-primary"></i>
                <strong>Информация о блокировке:</strong>
              </p>
              <p className="text-muted small mb-1">{reason.message}</p>
              <p className="text-muted small mb-0">
                Время: {new Date(reason.timestamp).toLocaleString('ru-RU')}
              </p>
              <p className="text-muted small mb-0 mt-2">
                <i className="bi bi-tag me-1"></i>
                Источник: {reason.source || 'unknown'}
              </p>
            </div>
          )}

          {autoChecking && (
            <div className="mb-4 text-primary">
              <Spinner animation="border" size="sm" className="me-2" />
              <span>Проверка статуса аккаунта...</span>
            </div>
          )}

          {message && (
            <Alert variant={message.includes('✅') ? 'success' : message.includes('❌') ? 'danger' : 'info'} className="mb-4">
              {message}
            </Alert>
          )}

          <div className="bg-light p-3 rounded mb-4 text-start">
            <p className="mb-2">
              <i className="bi bi-info-circle me-2 text-primary"></i>
              <strong>Что делать:</strong>
            </p>
            <ul className="text-muted small mb-0">
              <li>Свяжитесь с администратором для активации аккаунта</li>
              <li>После активации нажмите кнопку "Выйти и войти снова"</li>
              {/* <li>Или выйдите и войдите снова</li> */}
            </ul>
          </div>

          <div className="d-grid gap-2">
            <Button 
              variant="warning" 
              onClick={handleGoToLogin}
              className="py-2"
            >
              <i className="bi bi-box-arrow-right me-2"></i>
              Выйти и войти снова
            </Button>
            
            {/* <Button 
            variant="outline-danger" 
            onClick={() => {
                localStorage.removeItem('inactive_reason');
                window.location.reload();
            }}
            className="py-2 mt-2"
            >
            <i className="bi bi-trash me-2"></i>
            Принудительно очистить блокировку
            </Button> */}

            {/* <Button 
              variant="outline-primary" 
              onClick={handleForceCheck}
              className="py-2"
              disabled={checking}
            >
              {checking ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Проверка статуса...
                </>
              ) : (
                <>
                  <i className="bi bi-arrow-clockwise me-2"></i>
                  Проверить статус аккаунта
                </>
              )}
            </Button> */}
            
            <Button 
              variant="outline-secondary" 
              onClick={() => window.location.reload()}
              className="py-2"
            >
              <i className="bi bi-arrow-clockwise me-2"></i>
              Обновить страницу
            </Button>
          </div>

          <hr className="my-4" />

          <p className="text-muted small mb-0">
            Если вы считаете, что это ошибка, свяжитесь с поддержкой:
          </p>
          {/* <a 
            href="mailto:support@taskit.ru" 
            className="text-decoration-none small"
          >
            <i className="bi bi-envelope me-1"></i>
            support@taskit.ru
          </a> */}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default InactiveAccountPage;